export const project = 'cdl'; // need this for when we dynamically import utils

/**
 * Sending function for CDL project
 * Pushes payloads to window.coxAutoDataLayer
 *
 * @param {Object} params - Parameters object
 * @param {Window} params.win - The window object
 * @param {Object} params.data - The payload to send
 * @param {boolean} params.preview - Whether in preview mode
 */
export const sending = ({ win, data: payload, preview }) => {
	const reportsForEventViewer = [];
	const reportsForNewRelic = [];

	if (!preview) {
		// Push to coxAutoDataLayer
		win.coxAutoDataLayer.push(payload);
	}

	const sender = 'coxAutoDataLayer';

	reportsForEventViewer.push({
		clientEventName: payload?.event?.category || 'cdl_event',
		payload,
		sender
	});

	reportsForNewRelic.push({
		clientEventName: payload?.event?.category || 'cdl_event',
		sender
	});

	return {
		reportsForEventViewer,
		reportsForNewRelic
	};
};
